import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {};
const qs = {
  paginator: 'data-paginator',
  results: 'data-pagination-result',
  itemsText: 'data-items-text',
  nav: 'data-pagination-nav',
}
const qsAll = {
  loadMoreBtns: 'data-load-more',
}

const attachLoadMoreEvent = (btn) => {
  btn.addEventListener('click', (e) => {
    e.preventDefault()
    e.stopPropagation()
    const paginator = btn.closest(`[${qs.paginator}]`)
    if(paginator) {
      const results = paginator.querySelector(`[${qs.results}]`)
      fetch(btn.href, { method: 'GET' })
        .then((response) => response.text())
        .then((html) => {
          const parsedHtml = new DOMParser().parseFromString(html, 'text/html')
          const newResults = parsedHtml.querySelectorAll(`[${qs.results}] > *`)

          newResults.forEach((child) => {
            results.appendChild(child)
          })

          btn.remove()
          if(parsedHtml.querySelector(`[${qsAll.loadMoreBtns}]`)) {
            const node = document.createElement("a")
            node.href = `${parsedHtml.querySelector(`[${qsAll.loadMoreBtns}]`).href}`
            node.className = "mt-12 button button--secondary mx-auto inline-block"
            node.setAttribute('data-load-more', '')
            node.textContent = 'More Results'
            paginator.querySelector(`[${qs.nav}]`).insertBefore(node, paginator.querySelector(`[${qs.itemsText}]`))
            attachLoadMoreEvent(paginator.querySelector(`[${qsAll.loadMoreBtns}]`))
          }
          paginator.querySelector(`[${qs.itemsText}]`).innerHTML = parsedHtml.querySelector(`[${qs.itemsText}]`).innerHTML

          // Render Product Tiles
          window.setupProductTiles(document.querySelectorAll('[product-tile="false"]'))
        })
    }
  })
}

export const setupPaginations = () => {
  cacheDom(dom, qs, qsAll)
  dom.loadMoreBtns.forEach((btn) => {
    attachLoadMoreEvent(btn)
  })
}